import { render, staticRenderFns } from "./base.modal.vue?vue&type=template&id=13b8f99c&scoped=true"
import script from "./base.modal.vue?vue&type=script&lang=js"
export * from "./base.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.5.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8f99c",
  null
  
)

export default component.exports